module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal reactivatedxpnewmodal",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.reactivate))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.reactivatedxpnewmodal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t          " + _vm._s(_vm.dxpnewcurrentName) + " ")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dxpnewcurrentId),
      expression: "dxpnewcurrentId"
    }],
    staticClass: "form-control col-lg-12 col-md-12 col-sm-12 col-xs-12",
    attrs: {
      "id": "message-text",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.dxpnewcurrentId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dxpnewcurrentId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendNewDxpReInvite($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.yes))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.reactivatedxpnewmodal')
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.no))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal adminErrorModal",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v("\n            Error\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.adminErrorModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_vm._v("\n\t\t        " + _vm._s(_vm.errorAdminMsg) + "\n\t\t      ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.adminErrorModalClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.activationOk))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal resetpwdemodal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.resetpwd))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.resetSuccess),
      expression: "!resetSuccess"
    }],
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.wanttoreset) + " ")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resetSuccess),
      expression: "resetSuccess"
    }],
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.resetSuccessMsg))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentId),
      expression: "currentId"
    }],
    staticClass: "form-control col-lg-12 col-md-12 col-sm-12 col-xs-12",
    attrs: {
      "id": "message-text",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.currentId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.resetSuccess),
      expression: "!resetSuccess"
    }],
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetPassword($event)
      }
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.yes))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.resetSuccess),
      expression: "!resetSuccess"
    }],
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.no))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resetSuccess),
      expression: "resetSuccess"
    }],
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.close))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal reactivatemodal",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.reactivate))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.reactivatemodal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.wanttoreactivate) + " ")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentId),
      expression: "currentId"
    }],
    staticClass: "form-control col-lg-12 col-md-12 col-sm-12 col-xs-12",
    attrs: {
      "id": "message-text",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.currentId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendReInvite($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.yes))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.reactivatemodal')
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.no))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal dxpmodal",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.user_lang.activationTitle) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.dxpmodal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t        " + _vm._s(_vm.user_lang.activationDescription) + " ")])]), _vm._v(" "), _vm._l((_vm.dxpList), function(data) {
    return _c('div', {
      staticStyle: {
        "margin-right": "233px",
        "width": "100%",
        "text-align": "left"
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": data.id,
        "name": "activation"
      },
      domProps: {
        "value": data.id
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": data.id
      }
    }, [_vm._v(" " + _vm._s(data.label) + " " + _vm._s(_vm.user_lang.template))])])
  }), _vm._v(" "), _vm._l((_vm.nonDxpList), function(data, index) {
    return (index === 0) ? _c('div', {
      staticStyle: {
        "margin-right": "233px",
        "width": "100%",
        "text-align": "left"
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": data.id,
        "name": "activation",
        "checked": "checked"
      },
      domProps: {
        "value": 0
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": data.id
      }
    }, [_vm._v(_vm._s(_vm.user_lang.cargillActivation))])]) : _vm._e()
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentId),
      expression: "currentId"
    }],
    staticClass: "form-control col-lg-12 col-md-12 col-sm-12 col-xs-12",
    attrs: {
      "id": "message-text",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.currentId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendDxpReInvite($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.activationOk))])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal newdxpmodal",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.user_lang.activationTitle) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.newdxpmodal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t        " + _vm._s(_vm.user_lang.activationDescription) + " ")])]), _vm._v(" "), _vm._l((_vm.dxpList), function(data) {
    return _c('div', {
      staticStyle: {
        "margin-right": "233px",
        "width": "100%",
        "text-align": "left"
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": data.id,
        "name": "activation"
      },
      domProps: {
        "value": data.id
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": data.id
      }
    }, [_vm._v(" " + _vm._s(data.label) + " " + _vm._s(_vm.user_lang.template))])])
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendDxpReInvite($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.activationOk))])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal permissiondeniedreset",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('button', {
    staticClass: "close",
    staticStyle: {
      "text-align": "right",
      "margin": "10px 20px 0px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "width": "90%"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.permissiondeniedreset) + " ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal permissiondeniedmodal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('button', {
    staticClass: "close",
    staticStyle: {
      "text-align": "right",
      "margin": "10px 20px 0px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "width": "90%"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.permissiondenied) + " ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal nonanoktausermodal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('button', {
    staticClass: "close",
    staticStyle: {
      "text-align": "right",
      "margin": "10px 20px 0px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "width": "90%"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.nonanoktauser) + " ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal ativateanddeactivaeemodal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.requestType === 'deleteoktauser' ? _vm.user_lang.delete : _vm.statusCode == 0 ? _vm.user_lang.activateDeactivate.split('/')[0] : _vm.user_lang.activateDeactivate.split('/')[1]))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusCode == 0),
      expression: "statusCode==0"
    }],
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.user_lang.wanttoactivate))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusCode == 1),
      expression: "statusCode==1"
    }],
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.requestType === 'deleteoktauser' ? _vm.user_lang.wanttodelete : _vm.user_lang.wanttodeactivate))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusCode),
      expression: "statusCode"
    }],
    staticClass: "form-control col-lg-12 col-md-12 col-sm-12 col-xs-12",
    attrs: {
      "id": "message-text",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.statusCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.statusCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentemailId),
      expression: "currentemailId"
    }],
    staticClass: "form-control col-lg-12 col-md-12 col-sm-12 col-xs-12",
    attrs: {
      "id": "message-text",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.currentemailId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentemailId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deactivateUser($event)
      }
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.yes))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.no))]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalCount !== '' && !_vm.groupDeleted),
      expression: "totalCount !== '' && !groupDeleted"
    }],
    staticClass: "showingnusers",
    class: {
      'v-hidden': _vm.showfloatingcount
    },
    staticStyle: {
      "padding-top": "10px",
      "text-align": "center",
      "font-size": "14px",
      "background": "#fff",
      "margin": "0px -15px"
    }
  }, [_vm._v("\n\t" + _vm._s(_vm.user_lang.showing) + " 1 - " + _vm._s(_vm.rows.length) + " " + _vm._s(_vm.user_lang.of) + " " + _vm._s(_vm.totalCount) + " " + _vm._s(_vm.user_lang.userword))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalCount !== ''),
      expression: "totalCount !== ''"
    }],
    staticClass: "outOfView",
    class: {
      'v-hidden': !_vm.showfloatingcount
    },
    staticStyle: {
      "padding-top": "10px",
      "text-align": "center",
      "font-size": "14px",
      "background": "#fff",
      "margin": "0px -15px"
    }
  }, [_vm._v("\n\t" + _vm._s(_vm.user_lang.showing) + " 1 - " + _vm._s(_vm.rows.length) + " " + _vm._s(_vm.user_lang.of) + " " + _vm._s(_vm.totalCount) + " " + _vm._s(_vm.user_lang.userword))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMoreString !== undefined && _vm.showMoreString !== ''),
      expression: "showMoreString !== undefined && showMoreString !== ''"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), (_vm.groupDeleted) ? _c('div', {
    staticClass: "no-group"
  }, [_vm._v(_vm._s(_vm.user_lang.groupUnavailable))]) : _vm._e(), _vm._v(" "), _c('vue-good-table', {
    attrs: {
      "id": "table",
      "columns": _vm.columns,
      "rows": _vm.rows,
      "paginate": false,
      "paginateOnTop": true,
      "lineNumbers": false,
      "responsive": true,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: '_embedded.user.profile.updatelink',
          type: 'asc'
        }
      }
    }
  }, [_c('div', {
    staticClass: "no-data",
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n    " + _vm._s(_vm.user_lang.noTableData) + "\n  ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMoreString !== undefined && _vm.showMoreString !== ''),
      expression: "showMoreString !== undefined && showMoreString !== ''"
    }],
    staticStyle: {
      "text-align": "center",
      "height": "65px"
    }
  }, [_c('button', {
    staticClass: "btn",
    class: {
      disabled: _vm.loading
    },
    staticStyle: {
      "color": "#fff",
      "height": "35px",
      "padding": "0px 20px",
      "background": "#ccc"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.showMore()
      }
    }
  }, [_vm._v("\n" + _vm._s(_vm.user_lang.showmore) + " ")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-01537783", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01537783"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserTable.vue
// module id = 698
// module chunks = 1